"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlertIconContainer = exports.AlertDescription = exports.AlertHeading = exports.AlertContainer = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const themed_text_1 = require("../themed-text");
const setBorderColor = (props) => {
    const { alertType, theme } = props;
    return (0, styled_components_1.css) `
    border-color: ${theme.palettes.alert[alertType || 'warning']};
  `;
};
exports.AlertContainer = styled_components_1.default.div `
  ${setBorderColor};
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  border-style: solid;
  border-width: 2px;
  border-left-width: 12px;
  border-radius: 8px;
  width: 100%;
  padding: 14px 18px 18px;
  margin: ${(props) => props.margin};
  max-width: ${(props) => props.maxWidth};
`;
exports.AlertHeading = (0, styled_components_1.default)(themed_text_1.ThemedHeading) `
  padding-left: 8px;
  padding-bottom: 0;
  width: calc(100% - ${({ iconSize }) => iconSize}px);
`;
exports.AlertDescription = (0, styled_components_1.default)(themed_text_1.ThemedSpan) `
  padding-top: 10px;
`;
exports.AlertIconContainer = styled_components_1.default.div `
  display: flex;
  margin-top: 2px;
`;
